import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router';

const { Title } = Typography;

interface Props {
  title: string; // The main title text to display
  showBackButton?: boolean; // Whether to show the back button
  extra?: React.ReactNode; // Additional elements to display on the right side
}

/**
 * A reusable page title component with optional back button and action items
 *
 * Features:
 * - Consistent page title styling
 * - Optional back button with navigation
 * - Right-aligned action area for buttons or other elements
 * - Responsive layout
 *
 * Usage:
 * <PageTitle
 *   title="Dashboard"
 *   showBackButton
 *   extra={<Button>Action</Button>}
 * />
 */
export const PageTitle: FC<Props> = ({ title, extra, showBackButton }) => {
  const navigate = useNavigate();
  return (
    <Flex justify="space-between" className="w-full mb-1 h-10" align="center">
      <Flex gap={10} align="center">
        {showBackButton && (
          <Button
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          />
        )}
        <Title level={4} style={{ marginBottom: 0 }}>
          {title}
        </Title>
      </Flex>
      <Flex>{extra}</Flex>
    </Flex>
  );
};
